
import { FirearmPoolMetadataBase } from './firearm-pool.metadata.base';


export class FirearmPoolMetadata extends FirearmPoolMetadataBase {
  constructor() {
    super();
  }
}

export const FIREARM_POOL_METADATA: FirearmPoolMetadata = new FirearmPoolMetadata();


